import { Controller } from "stimulus";
import { placeBeside } from "../../training_grooming_calendar/pointer";
import { openDisclosure, closeOverlay } from "../../training_grooming_calendar/overlay";
import { arrangeCard } from "../../training_grooming_calendar/schedule_card";

export default class extends Controller {
  static targets = ["container"];

  show(event) {
    const schedule = event.currentTarget;
    this.hide();
    const line = schedule.closest(".tg-sched-line");
    const card = line && line.querySelector(".tg-schedule-card");
    if (!card) return;
    this.arrange(card, schedule);
    this.schedule = schedule;
    this.line = line;
    this.card = card;
    schedule.classList.add("tg-schedule-hot");
    this.containerTarget.appendChild(card);
    card.classList.add("open");
    const spot = placeBeside({ anchor: schedule.getBoundingClientRect(), width: card.offsetWidth, height: card.offsetHeight, viewport: { width: window.innerWidth, height: window.innerHeight } });
    card.style.left = `${spot.left}px`;
    card.style.top = `${spot.top}px`;
    this.scroller = schedule.closest(".tg-day-scroll");
    this.handleScroll = () => this.hide();
    if (this.scroller) this.scroller.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  hide() {
    if (this.handleScroll) {
      if (this.scroller) this.scroller.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("scroll", this.handleScroll);
      this.handleScroll = null;
      this.scroller = null;
    }
    if (!this.schedule) return;
    this.schedule.classList.remove("tg-schedule-hot");
    this.card.classList.remove("open");
    this.line.appendChild(this.card);
    this.schedule = null;
    this.line = null;
    this.card = null;
  }

  arrange(card, schedule) {
    const list = card.querySelector(".tg-schedule-card-list");
    if (list) arrangeCard(list, { start: Number(schedule.dataset.start), end: Number(schedule.dataset.end) });
  }

  open(event) {
    const pill = event.currentTarget;
    const sheet = this.containerTarget.querySelector(`[data-schedule-sheet="${pill.dataset.scheduleId}"]`);
    if (!sheet) return;
    openDisclosure({ element: sheet, trigger: pill, root: this.element, sheet: true, triggerClass: "tg-m-sched-open" });
    const close = sheet.querySelector(".tg-sheet-close");
    if (close) close.focus({ preventScroll: true });
  }

  close() {
    closeOverlay();
  }

  reset() {
    this.hide();
  }
}
